import React from 'react';
import Head from 'next/head';
import HtmlParser from 'html-react-parser';
import BlogTypes from '../../../data/blog/types';
import Container from '../../atoms/Container';
import BlogDescricao from '../../molecules/BlogDescricao';
import BlogImage from '../../molecules/BlogImage';
import BlogPostsRecentes from '../../molecules/BlogPostsRecentes';
import BlogTextList from '../../molecules/BlogTextList/BlogTextList';
import BlogTexto from '../../molecules/BlogTexto';
import Footer from '../../organisms/Footer';
import Header from '../../organisms/Header';
import TextBanner from '../../organisms/TextBanner';
import Styles from './Blog.css';
import ArticleReview from '../../organisms/ArticleReview/ArticleReview';
import ArticleCTA from '../../organisms/ArticleCTA/ArticleCTA';
import BlogDataFeitoPor from '../../molecules/BlogDataFeitoPor';

function Blog({ post, recentPosts, showReturn }) {
  const headSeo = HtmlParser(post.seo.head);
  return (
    <>
      <Head>
        <title>{post.seo.title}</title>
        <meta name="Description" content={post.seo.description} />
        {headSeo}
      </Head>
      <Header importPrefix="../" />
      <section id="sec-blog-banner">
        <TextBanner
          enablePreload
          enableDesktopTopMargin
          src={post.banner?.src}
          usesDesktopImage={!!post.banner?.desktopSrc}
          desktopSrc={post.banner?.desktopSrc}
          altimg={post.banner?.alt}
          imgPositionRight={post.banner?.imgPositionRight}
          imgPositionRightDesk={post.banner?.imgPositionRightDesk}
        >
          {post.title}
        </TextBanner>
      </section>
      <Container noPadding type="section" id="sec-blog-content">
        <Container noPadding>
          <BlogDescricao>{post.description}</BlogDescricao>
          {post.content.map((c, i) => {
            return (
              <section id={`sec-blog-content-item-${i}`} key={`blog-content-${i}`}>
                {c.type === BlogTypes.RAW_TEXT && (
                  <BlogTexto
                    title={c.title}
                    subtitle={c.subtitle}
                    h4title={c.h4title}
                    text={c.text}
                  />
                )}

                {c.type === BlogTypes.SINGLE_IMAGE && (
                  <BlogImage
                    enablePreload
                    src={c.src}
                    desktopSrc={c.desktopSrc}
                    altImg={c.alt}
                    width={c.width}
                    height={c.height}
                    desktopwidth={c.desktopwidth}
                    desktopheight={c.desktopheight}
                    isresized={c.isresized}
                    marginbottom={c.marginbottom}
                  />
                )}

                {c.type === BlogTypes.TEXT_LIST && (
                  <BlogTextList title={c.title} textList={c.textList} />
                )}
                {c.type === BlogTypes.DATA_FEITO_POR && (
                  <BlogDataFeitoPor data={c.data} feitopor={c.feitopor} />
                )}
              </section>
            );
          })}

          <section id="sec-blog-article-review">
            <ArticleReview slug={post.slug} />
          </section>

          {showReturn && (
            <section id="sec-blog-go-back">
              <Container extraPadding>
                <a href="../blog.html">Voltar para o blog</a>
              </Container>
            </section>
          )}
        </Container>
        <section id="sec-blog-cta-mobile">
          <ArticleCTA cta={post.cta} enableButton disableText />
        </section>
        <section id="sec-blog-cta">
          <ArticleCTA cta={post.cta} enableButton={false} />
        </section>
      </Container>

      {recentPosts && recentPosts.length > 0 && (
        <section id="sec-blog-recent-posts">
          <Container extraPadding>
            <BlogPostsRecentes posts={recentPosts} />
          </Container>
        </section>
      )}
      <Footer importPrefix="../" />
      <style jsx>{Styles}</style>
    </>
  );
}

export default Blog;
